/**
 * Improves automatic scrolling to the first validation error in Filament Forms.
 *
 * By default, Filament Forms triggers `scrollIntoView()` on the first field with a validation error.
 * This behavior is defined in the Filament Forms package:
 * @see https://github.com/filamentphp/filament/blob/1f8c869ca09bd176c9e6d1b9e29478c4a74017c4/packages/forms/resources/views/component-container.blade.php#L10-L40
 *
 * This script overrides the default `scrollIntoView()` behavior while preserving
 * Filament's form validation event handling. This override seeks to avoid
 * unnecessary scrolling when the errored field (and its label and error message)
 * is already within the viewport.
 *
 * Notes:
 * - This does not interfere with Filament’s form validation logic or field expansion.
 * - If Filament updates its scrolling behavior in future versions, revisit this script.
 * - The value added to `top` should correspond to `scroll-margin-top` in CSS.
 */
export function improveFilamentScroll() {
	document.addEventListener('DOMContentLoaded', function () {
		window.addEventListener('form-validation-error', function () {
			setTimeout(() => {
				document.querySelectorAll('[data-validation-error]').forEach((error) => {
					if (error.closest('[data-field-wrapper]')) {
						// Save a reference to the original `scrollIntoView()` function
						if (!error.closest('[data-field-wrapper]').scrollIntoViewOriginal) {
							error.closest('[data-field-wrapper]').scrollIntoViewOriginal = error.closest('[data-field-wrapper]').scrollIntoView;
						}

						error.closest('[data-field-wrapper]').scrollIntoView = function (options) {
							const headerElement = document.querySelector('.js-header');
							const scrollMarginTop = (headerElement ? headerElement.offsetHeight : 0) + 24;

							// Set `scroll-margin-top`, which is respected by the native `scrollIntoView()` method
							this.style.scrollMarginTop = scrollMarginTop + 'px';

							// Determine if this element is already within the viewport
							// See: https://stackoverflow.com/a/7557433
							const rectangle = this.getBoundingClientRect();
							if (
								rectangle.top >= scrollMarginTop && // this should correspond to `scroll-margin-top` in CSS (must be in pixels)
								rectangle.left >= 0 &&
								rectangle.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
								rectangle.right <= (window.innerWidth || document.documentElement.clientWidth)
							) {
								return;
							}

							this.scrollIntoViewOriginal(options);
						};
					}
				});
			}, 100);
		});
	});
}
